"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Offer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = _interopRequireWildcard(require("./SvgIcon"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Offer = exports.Offer = function Offer(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], _extends({
    fill: "none"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.25 3v18h13.5V3H5.25zm15 19.5H3.75v-21h16.5v21z",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    d: "M12.7328 5.25v1.6194c.6261.205 1.2154.5837 1.6365 1.1383l-1.1947.907c-.3519-.4635-.9933-.7378-1.5992-.7269l-.0068.0001h-.0067c-.7311 0-1.0272.2797-1.1275.4679-.107.201-.1022.4913.1201.7639.0166.0203.0861.0835.3117.1494.2225.065.4956.1054.841.153l.0487.0066c.3113.0427.6793.0932 1.0196.1829.3567.094.7681.2512 1.0976.5631 1.2547 1.1877.6485 3.3379-1.1403 3.736V15.75h-1.5v-1.4495c-.3209-.0219-.6256-.0744-.9146-.1631-.659-.2024-1.187-.5785-1.6182-1.111l1.1656-.9441c.2594.3203.5423.5134.8931.6212.3677.113.8563.146 1.54.0616.7823-.0966.8893-.8734.5433-1.201-.0647-.0612-.195-.1352-.4488-.2021-.2502-.0659-.5379-.1055-.8822-.1528l-.0091-.0013c-.3235-.0445-.709-.0975-1.0563-.1989-.3445-.1007-.7563-.277-1.0533-.6411-.5667-.6945-.7-1.6321-.2818-2.4173.383-.719 1.1457-1.1675 2.1223-1.2492V5.25h1.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.5 19.5h-9V18h9v1.5z",
    clipRule: "evenodd"
  }));
};
Offer.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.keys(_SvgIcon.KIND)),
  size: _propTypes["default"].oneOf(Object.keys(_SvgIcon.SIZE)),
  title: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(Object.keys(_SvgIcon.COLOR)),
  htmlColor: _propTypes["default"].string,
  fontSize: _propTypes["default"].oneOf(['medium', 'inherit', 'small', 'large']),
  viewBox: _propTypes["default"].string
} : {};
Offer.defaultProps = {
  viewBox: '0 0 24 24'
};
var _default = exports["default"] = Offer;